import { useMemo } from "react";
import { Endpoints, queryKeys } from "../api";
import { useAuth, useTerritories } from "../contexts";
import { getRequestOptions } from "../helper-functions";
import { useAxios, useGenericQuery } from "../hooks";
import { QueryResult, QueryParams, Auditable } from "../models";
import { Lists } from "../components";

export interface IUseListQuery {
    listQuery: QueryResult<Auditable[]>;
}

export interface UseListQueryParams {
    listSlug?: string;
    listDate?: string;
    territoryId?: string;
}

export const useListQuery = (params?: UseListQueryParams): IUseListQuery => {
    const listSlug = params?.listSlug ?? "";
    const listDate = params?.listDate ?? "";
    const { selectedOfficeIds, selectedTerritoryIds } = useTerritories();
    const territoryIds = params?.territoryId ?? selectedTerritoryIds.join(",");
    const { isAuthorized } = useAuth();
    const { get } = useAxios();
    const url = Endpoints.Lists;

    const queryParams: QueryParams = {
        officeIds: selectedOfficeIds.join(","),
        territoryIds: territoryIds,
        listSlug,
        listDate,
    };

    const listQuery = useGenericQuery({
        queryFn: (config) => get<Auditable[]>(getRequestOptions(url, config, queryParams)),
        queryKey: queryKeys.lists.list({ ...queryParams }),
        placeholderData: [],
        enabled: isAuthorized && !!listSlug && listSlug !== Lists.None,
        cacheTime: 2000,
        staleTime: 2000,
    });

    return useMemo<IUseListQuery>(
        () => ({
            listQuery,
        }),
        [listQuery]
    );
};
